import { render, staticRenderFns } from "./PriceListAddProduct.vue?vue&type=template&id=36b442bc&"
import script from "./PriceListAddProduct.vue?vue&type=script&lang=js&"
export * from "./PriceListAddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports